
import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navigation from "./components/Navbar";

import LandingPage from "./components/LandingPage";
import NotesPage from "./components/NotesPage";
import axios from "axios";
import AOS from "aos";
import "aos/dist/aos.css";
import ContactUs from "./components/Contact";
import About from "./components/About";
import Footer from "./components/Footer";
import VV from "./components/VideoSection";
import SectionDivider from "./components/SectionDivider";
import Testimonials from "./components/Testimonials";

AOS.init();

function App() {
  const [notes, setNotes] = useState([]);

  useEffect(() => {
       axios.get('https://lepic.onrender.com/api/notes')
      .then(res => setNotes(res.data))
      .catch(err => console.log(err));
  }, []);

  return (
    // <BrowserRouter>
    //   <Navigation />
    //   <Routes>
    //     <Route path="/" element={<LandingPage />} />
    //     <Route path="/notes" element={<NotesPage notes={notes} />} />
    //   </Routes>
    //   <Footer />
    // </BrowserRouter>
    <BrowserRouter>
      <Navigation />
  <Routes>

    <Route path="/" element={<LandingPage />} />
    
    <Route path="/notes" element={<NotesPage notes={notes} />} />
  </Routes>
  <SectionDivider/>
  <About/>
 <SectionDivider/>
<VV/>
<SectionDivider/>
<Testimonials/>
<SectionDivider/>
  <ContactUs/>
  <SectionDivider/>
<Footer/>

</BrowserRouter>

  );
}

export default App;
